import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PosIntegrationService } from '../../../../../services/pos-integration.service';

@Component({
  selector: 'app-callback-vend',
  templateUrl: './callback-vend.component.html',
  styleUrls: ['./callback-vend.component.scss'],
})
export class CallbackVendComponent implements OnInit {
  public broadcastChannel = new BroadcastChannel('VEND_CHANNEL');

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private posIntegrationService: PosIntegrationService,
  ) {}

  ngOnInit() {
    let PartnerID = localStorage.getItem('VendPartnerID');
    this.activatedRoute.queryParams.subscribe((params) => {
      var data = {
        ID: parseInt(PartnerID),
        PhoneNumber1: params['code'],
        PhoneNumber2: params['domain_prefix'],
      };
      this.posIntegrationService.registerVend(data).subscribe(
        (result) => {
          this.broadcastChannel.postMessage('CONNECTED');
          setTimeout(() => {
            window.close();
          }, 500);
        },
        (err) => {
          this.broadcastChannel.postMessage('NOT_CONNECTED');
          window.close();
        },
      );
    });
  }
}
